<template>
	<div class="app-textarea">
		<label
			v-if="$slots.default"
			class="app-textarea__label"
		>
			<span v-if="$attrs.required" class="require-mark">*</span>
			<slot></slot>
		</label>

		<textarea
			class="app-textarea__input"
			:class="{'app-textarea__input--error' : hasError}"
			v-bind="$attrs"
			v-on="inputListener"
		>
		</textarea>

		<p class="app-textarea__max" v-if="$attrs.maxlength">
			{{ count }}
		</p>

		<p
			v-if="hasError"
			class="app-textarea__error"
		>
			{{ error || invalidMessage }}
		</p>
	</div>
</template>

<script>
export default {
	inheritAttrs: false,
	props: {
		error: String,
		hideCount: Boolean
	},

	data () {
		return {
			invalidMessage: null
		}
	},

	computed: {
		hasError () {
			return this.error || this.invalidMessage
		},

		inputListener () {
			return {
				...this.$listeners,
				invalid: this.setInvalidMessage,
				input: this.inputHandler
			}
		},

		count () {
			if (!this.$attrs.maxlength) return ''
			if (!this.$attrs.value) return this.$attrs.maxlength
			return Number(this.$attrs.maxlength) - Number(this.$attrs.value.length)
		}
	},

	methods: {
		inputHandler (event) {
			this.invalidMessage = ''
			this.$emit('input', event.target.value)
		},

		setInvalidMessage (event) {
			event.preventDefault()
			if (event.target.validity.valueMissing) {
				this.invalidMessage = 'Fill up this field'
			} else {
				this.invalidMessage = event.target.validationMessage
			}
		}
	}
}
</script>

<style lang="scss" scoped>
.app-textarea {
	display: inline-block;
	position: relative;
	font-size: 1em;
	width: 100%;

	&__label, &__input {
		font-weight: normal;
		font-family: inherit;
		font-size: inherit;
		display: block;
		width: 100%;
	}

	&__label {
		color: $default;
		margin-bottom: .5em;

		.require-mark {
			color: $danger;
		}
	}

	&__input {
		outline: none;
		border: none;
		border: 1px solid $default-light;
		padding: 5px 8px;
		border-radius: 3px;
		background-color: #fff;
		color: $default;
		width: 100%;
		height: 100%;
		min-height: 100px;
		resize: none;

		&::placeholder {
			color: $default-light;
			font-size: 1em;
		}

		&:focus {
			caret-color: $primary;
		}

		&:disabled {
			pointer-events: none;
		}

		&:hover {
			border-color: $primary;
		}

		&:disabled {
			pointer-events: none;
			opacity: 0.5;
		}

		&--error {
			border-color: $danger;

			&:hover {
				border-color: $danger;
			}
		}
	}

	&__max {
		margin-top: .5em;
		text-align: right;
		color: $default-light;
	}

	&__error {
		color: $danger;
		margin-top: .5em;
		display: flex;
		justify-content: flex-end;
	}
}
</style>
